import type { RefObject } from 'react';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import type { View } from 'react-native';

type OnTextLayout = (e: unknown) => void;

export type UseIsTextClampedResult = {
  isClamped: boolean;
  onTextLayout: OnTextLayout;
  ref: RefObject<View | null>;
};

export const useIsTextClamped = (maxLines?: number): UseIsTextClampedResult => {
  const [isClamped, setIsClamped] = useState(false);
  const ref = useRef<View | null>(null);

  useLayoutEffect(() => {
    if (maxLines == undefined || !ref.current) return;
    const wrapper = ref.current as unknown as HTMLElement;
    const textEl = wrapper.firstElementChild as HTMLElement | null;
    if (textEl) {
      setIsClamped(textEl.scrollHeight > textEl.clientHeight + 1);
    }
  }, [maxLines]);

  const onTextLayout = useCallback(() => {}, []);

  return { isClamped, onTextLayout, ref };
};
